import { useTypedParams } from '@sorare/routing';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { EssenceLayout as EssenceLayoutComponent } from 'layouts/my-cards/EssenceLayout';

import type { PageParams } from './__generated__/routeParams';

const EssenceLayout = () => {
  const { type } = useTypedParams<PageParams>();
  return <EssenceLayoutComponent type={type as Rarity} />;
};

export default EssenceLayout;
